import React, { useEffect } from 'react';

const NearPOI = () => {
  // Tambahkan useEffect atau handler untuk menangkap error Google Maps
  useEffect(() => {
    // Error handler untuk Google Maps API
    window.gm_authFailure = () => {
      alert('API Key tidak valid atau tidak diizinkan untuk domain ini. Silakan hubungi administrator.');
      window.location.href = '/unauthorized';
    };
    
    return () => {
      delete window.gm_authFailure;
    };
  }, []);

  return (
    <div>
      <h1>Nearby Points of Interest</h1>
      {/* ...existing code for displaying nearby POIs... */}
    </div>
  );
};

export default NearPOI;